var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.headerComponent,{tag:"component"}),_c('router-view'),_c(_vm.footerComponent,{tag:"component"}),_c(_vm.cookieComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }